export const formFields = [
  {
    section: "General Information",
    name: "aosAccumOvrdSchedule",
    label: "Schedule",
    fieldLabel: "AOS Accum Ovrd Schedule",
    type: "text",
    options: {
      maxLength: {
        value: 15,
        message: "Cannot exceed more than 15 characters",
      },
    },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [5, 12],
  },
  {
    section: "General Information",
    name: "aosAccumOvrdScdeDesc",
    label: "Description",
    fieldLabel: "AOS Accum Ovrd Scde Desc",
    type: "text",
    options: {
      maxLength: {
        value: 25,
        message: "Cannot exceed more than 25 characters",
      },
    },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [6, 12],
  },
  {
    section: "General Information",
    name: "aosAccumOvrdScdeType",
    label: "Type",
    fieldLabel: "AOS Accum Ovrd Scde Type",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {
      maxLength: { value: 1, message: "Cannot exceed more than 1 characters" },
    },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [7, 12],
  },
  {
    section: "General Information",
    name: "aocSeqNbr",
    label: "Sequence",
    fieldLabel: "AOC Seq Nbr",
    type: "number",
    options: { max: { value: 999, message: "Cannot exceed more than 999" } },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [8, 12],
  },
  {
    section: "General Information",
    name: "aotStateCsrLevel",
    label: "State CSR Level",
    fieldLabel: "AOT State CSR Level",
    type: "lookup",
    externalProgram: { default: "RCSCS004" },
    params: {
      lookupType: "local",
      viewType: "legacy",
      fieldMapping: {
        default: [
          {
            source: "aotStateCsrLevel",
            target: "level",
            legacy: "scsStateCsrLevel",
          },
        ],
      },
    },
    options: {
      required: { value: true, message: "Value required" },
      // maxLength: { value: 2, message: "Cannot exceed more than 2 characters" },
    },
    fieldNature: "Add: Editable, Change: Read-only, View: Read-only",
    position: [9, 21],
  },
  {
    section: "General Information",
    name: "aotScheduleOvrd",
    label: "Schedule Override",
    fieldLabel: "AOT Schedule Ovrd",
    type: "lookup",
    externalProgram: {
      O: "RCOPC005",
      T: "RCTSC003",
      E: "RCTSC003",
      D: "RCDSC005",
      B: "RCBSC005",
      L: "RCBSC005",
    },
    params: {
      lookupType: "conditional",
      viewType: "conditional",
      dataKey: "aosAccumOvrdScdeType",
      fieldMapping: {
        B: [{ source: "aotScheduleOvrd", target: "bscScheduleName" }],
        O: [{ source: "aotScheduleOvrd", target: "opcScheduleName" }],
        T: [{ source: "aotScheduleOvrd", target: "tscScheduleName" }],
        E: [{ source: "aotScheduleOvrd", target: "tscScheduleName" }],
        D: [{ source: "aotScheduleOvrd", target: "dscScheduleName" }],
        L: [{ source: "aotScheduleOvrd", target: "dscScheduleName" }],
      },
    },
    options: {
      required: { value: true, message: "Value required" },
      maxLength: {
        value: 10,
        message: "Cannot exceed more than 10 characters",
      },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [10, 21],
  },
  {
    section: "General Information",
    name: "aotStatus",
    label: "Status",
    fieldLabel: "Hidden Records Indicator",
    type: "dropdown",
    dropdownCondition: "*Inactive",
    options: {
      maxLength: { value: 1, message: "Cannot exceed more than 1 characters" },
    },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [11, 21],
  },
  {
    section: "Audit Fields",
    name: "addDateIso",
    label: "Added",
    fieldLabel: "ADD Date ISO",
    type: "date",
    options: {},
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [21, 20],
  },
  {
    section: "Audit Fields",
    name: "chgDateIso",
    label: "Changed",
    fieldLabel: "CHG Date ISO",
    type: "date",
    options: {},
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [21, 40],
  },
  {
    section: "Audit Fields",
    name: "chgUserName",
    label: "User",
    fieldLabel: "CHG User Name",
    type: "text",
    options: {
      maxLength: {
        value: 10,
        message: "Cannot exceed more than 10 characters",
      },
    },
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [21, 57],
  },
].sort(
  (a, b) => a.position[0] - b.position[0] || a.position[1] - b.position[1]
);
